<app-change-log
  [dataLoaded]="dataLoaded"
  (pageChanged)="onPageChanged($event)"
  [hideExportBtn]="true"
  [results]="changeLogResults">
</app-change-log>
